import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { legalCta, legalSection, legalToc, legalTranslationNotice } from '../components/legal.js';
import { site } from '../data/site.js';

const sections = [
  { id: 'terms-provider', titleKey: 'terms.provider.title' },
  { id: 'terms-services', titleKey: 'terms.services.title' },
  { id: 'terms-contract', titleKey: 'terms.contract.title' },
  { id: 'terms-cooperation', titleKey: 'terms.cooperation.title' },
  { id: 'terms-copyright', titleKey: 'terms.copyright.title' },
  { id: 'terms-warranty', titleKey: 'terms.warranty.title' },
  { id: 'terms-liability', titleKey: 'terms.liability.title' },
  { id: 'terms-confidentiality', titleKey: 'terms.confidentiality.title' },
  { id: 'terms-dataprotection', titleKey: 'terms.dataprotection.title' },
  { id: 'terms-final', titleKey: 'terms.final.title' },
];

export const TermsPage = () => page(html`
  <section class="pagehead pagehead--legal" aria-labelledby="terms-title">
    <div class="shell">
      ${breadcrumbs('nav.terms')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('terms.page.eyebrow')}</p>
          <h1 class="pagehead__title" id="terms-title">${t('terms.title')}</h1>
          <p class="pagehead__lede">${t('terms.page.description')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="kicker">${t('terms.header.subtitle')}</p>
          <p class="pagehead__note">
            <strong>NETBYTE UG (haftungsbeschränkt)</strong><br />
            ${t('terms.updated')}<br />
            ${t('contact.info.email')}: <a href="mailto:${site.email}">${site.email}</a>
          </p>
        </aside>
      </div>
    </div>
  </section>

  <section class="section legal">
    <div class="shell legal__layout">
      ${legalToc({
        titleKey: 'terms.summary.title',
        items: sections,
        meta: t('terms.updated'),
      })}
      <div class="legal__doc">
        ${legalTranslationNotice()}
        ${legalSection({
          id: 'terms-provider',
          iconName: 'building',
          titleKey: 'terms.provider.title',
          body: html`
            <p><strong>NETBYTE UG (haftungsbeschränkt)</strong></p>
            <p>${t('terms.provider.director')}: ${t('terms.provider.director.name')}</p>
            <p>Fährhofstraße 12<br />18439 Stralsund<br />${t('terms.provider.country')}</p>
            <p><strong>${t('contact.info.email')}:</strong> <a href="mailto:${site.email}">${site.email}</a></p>
            <p>${t('terms.provider.scope')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-services',
          iconName: 'check',
          titleKey: 'terms.services.title',
          body: html`
            <p>${t('terms.services.description')}</p>
            <p>${t('terms.services.list')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-contract',
          iconName: 'check',
          titleKey: 'terms.contract.title',
          body: html`
            <p>${t('terms.contract.offers')}</p>
            <p>${t('terms.contract.prices')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-cooperation',
          iconName: 'building',
          titleKey: 'terms.cooperation.title',
          body: html`
            <p>${t('terms.cooperation.customer')}</p>
            <p>${t('terms.cooperation.access')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-copyright',
          iconName: 'check',
          titleKey: 'terms.copyright.title',
          body: html`
            <p>${t('terms.copyright.ownership')}</p>
            <p>${t('terms.copyright.transfer')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-warranty',
          iconName: 'check',
          titleKey: 'terms.warranty.title',
          body: html`
            <p>${t('terms.warranty.content')}</p>
            <p>${t('terms.warranty.rectification')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-liability',
          iconName: 'check',
          titleKey: 'terms.liability.title',
          body: html`
            <p>${t('terms.liability.content')}</p>
            <p>${t('terms.liability.dataloss')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-confidentiality',
          iconName: 'check',
          titleKey: 'terms.confidentiality.title',
          body: html`
            <p>${t('terms.confidentiality.content')}</p>
            <p>${t('terms.confidentiality.continuation')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-dataprotection',
          iconName: 'check',
          titleKey: 'terms.dataprotection.title',
          body: html`
            <p>${t('terms.dataprotection.content')}</p>
            <p>${t('terms.dataprotection.more')}</p>
          `,
        })}

        ${legalSection({
          id: 'terms-final',
          iconName: 'check',
          titleKey: 'terms.final.title',
          body: html`
            <p>${t('terms.final.law')}</p>
            <p>${t('terms.final.invalidity')}</p>
            <p class="legal__updated">${t('terms.updated')}</p>
          `,
        })}

        ${legalCta()}
      </div>
    </div>
  </section>
`, { modifier: 'main--legal' });
